
import { AxiosResponse } from "axios";
import httpClient, { apiRoutePrefix } from "../httpClient/httpClient";
interface InstallShopifyResponse {
  url: string;
  message: string;
  success: boolean;
}
export const ShopifyService = {
  async installApp(
    installLink: string,
    clientSecret: string,
    botId?: string | number,
  ): Promise<AxiosResponse<InstallShopifyResponse>> {
    return httpClient.post(`${apiRoutePrefix}/shopify/install`, {
      installLink,
      clientSecret,
      botId,
    });
  },
  async getAppById(id: number): Promise<AxiosResponse> {
    return await httpClient.get<AxiosResponse>(`${apiRoutePrefix}/shopify/getShopifyAppById/${id}`);
  },
    async updateApp(storeId: any, botId: any): Promise<AxiosResponse> {
    const res = await httpClient.post<AxiosResponse>(
      `${apiRoutePrefix}/shopify/updateShopifyApp`,
      {
        storeId: storeId,
        botId: botId,
      }
    );
    return res;
  },
};
